import React, {useEffect, useRef, useState} from 'react';
import { observer } from 'mobx-react'
import './index.css';
import lang from "../../lang";
import logoeditor from '../../assets/logoeditor.svg';
import GlobalState, {changeSingleCompain} from "../../stores/GlobalState";
import { SSE } from 'sse.js';
import Domen from "../../stores/Domen";
import Typewriter from "../common/assistent/Typewriter"
import TruncatedText from "../common/Truncated/TruncatedText"
import AutoResizeTextarea from "../common/AutoResizeTextarea/AutoResizeTextarea"
import Lottie from 'lottie-react';
import Load from '../../assets/load.json';
import MarkdownRenderer from "../MarkdownRenderer/MarkdownRenderer";

const getNextItemById = (arr, id) => {
  const index = arr.findIndex(item => item.id === id);
  if (index === -1 || arr.length === 0) return null;
  return arr[(index + 1) % arr.length];
};

const getPrevItemById = (arr, id) => {
  const index = arr.findIndex(item => item.id === id);
  if (index === -1 || arr.length === 0) return null;
  return arr[(index - 1 + arr.length) % arr.length];
};

function TagBlock({ list, listAttribute }) {
  const containerRef = useRef(null);
  const [visibleCount, setVisibleCount] = useState(list.length);

  // 🔁 Це викликається лише коли list змінюється
    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const observer = new ResizeObserver(() => {
            requestAnimationFrame(() => calculateVisibleCount());
        });

        observer.observe(container);
        calculateVisibleCount(); // одразу при mount

        return () => observer.disconnect();
    }, []); // тільки один раз // не потрібно слухати listAttribute, бо list уже залежний від нього

  const calculateVisibleCount = () => {
    const container = containerRef.current;
    const items = container?.children;
    if (!items || items.length === 0) return;

    let rows = new Set();
    let maxRows = 2;
    let count = 0;

    for (let i = 0; i < items.length; i++) {
        const top = items[i].offsetTop;
        rows.add(top);
        if (rows.size > maxRows) break;
        count++;
    }

    setVisibleCount(prev => (prev !== count ? count : prev)); // захист
    };

  return (
    <div className="body_iactive_select" ref={containerRef}>
      {list.slice(0, visibleCount).map((item, index) => (
        <div key={index} className="body_iactive_select_bl">
          {item.name}
          <svg
            width="13"
            height="12"
            viewBox="0 0 13 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.8">
              <path
                d="M6.59546 5.13623C7.67508 5.13623 8.55029 4.26102 8.55029 3.1814C8.55029 2.10177 7.67508 1.22656 6.59546 1.22656C5.51583 1.22656 4.64062 2.10177 4.64062 3.1814C4.64062 4.26102 5.51583 5.13623 6.59546 5.13623Z"
                stroke="#007AFF"
                strokeWidth="0.8"
              />
              <path
                d="M10.5381 8.80173C10.5381 10.0162 10.5381 11.0009 6.62842 11.0009C2.71875 11.0009 2.71875 10.0162 2.71875 8.80173C2.71875 7.58729 4.4693 6.60254 6.62842 6.60254C8.78753 6.60254 10.5381 7.58729 10.5381 8.80173Z"
                stroke="#007AFF"
                strokeWidth="0.8"
              />
            </g>
          </svg>
          <span>{item.count}</span>
        </div>
      ))}

      {visibleCount < list.length && (
        <div className="body_iactive_select_bl extra-count">
          +{list.length - visibleCount}
        </div>
      )}
    </div>
  );
}

function isMarkdownTable(str) {
  if (typeof str !== "string") return false;
  const lines = str.trim().split('\n');
  if (lines.length < 3) return false;
  if (!lines[0].includes('|') || !lines[1].includes('|')) return false;
  // Друга лінія має містити тільки | і -
  const isSeparator = /^(\s*\|?\s*-+\s*)+\|?\s*$/.test(lines[1]);
  return isSeparator;
}

function parseMarkdownTable(md) {
  const lines = md.trim().split('\n').filter(Boolean);
  const headers = lines[0].split('|').map(h => h.trim()).filter(Boolean);
  const rows = lines.slice(2).map(line =>
    line.split('|').map(cell => cell.trim()).filter(Boolean)
  );
  return { headers, rows };
}

function MarkdownTable({ markdown }) {
  const { headers, rows } = parseMarkdownTable(markdown);
  return (
    <div style={{overflowX:"auto"}}>
      <table>
        <thead>
          <tr>
            {headers.map((h, i) => <th key={i}>{h}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) =>
            <tr key={i}>
              {row.map((cell, j) => <td key={j}>{cell}</td>)}
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}



const Assistant = observer(({ goal, comp }) => {
    const [langmenu, setLangmenu] = useState(localStorage.getItem("lang_site")||"en")
    const [langv, setLangv]= useState(langmenu=="de"?lang.de:lang.en)
    const [input, setInput] = useState("");
    const [profile, setProfile] = useState([]);
    const [guide, setGuide] = useState([]);
    const [products, setProducts] = useState([]);
    const [toolsProfile, setToolsProfile] = useState([]);
    const [letterProfile, setLetterProfile] = useState([]);
    const [profileName, setProfileName] = useState('');
    const [profileWeb, setProfileWeb] = useState('');
    const [profileDesc, setProfileDesc] = useState('');
    const [profileId, setProfileId] = useState('');
    const [guideToneOfVoice, setGuideToneOfVoice] = useState('');
    const [guidespamWord, setGuidespamWord] = useState('');
    const [guidelimitation, setGuidelimitation] = useState('');
    const [activemenu, setActiveMenu] = useState(1);
    const [morefunck, setmorefunck] = useState(false);
    const [editor1, setEditor1] = useState(false);
    const [activemess, setActivemess] = useState(false);
    const [activbut, setActivbut] = useState(false);
    const [allmessages, setAllmessages] = useState();
    const ref = React.useRef(null);
    var unlock = false
    const editorRef = useRef(null);
    const [isTextSelected, setIsTextSelected] = useState(false);
    const [messages, setMessages] = useState([]);
    const [attribute, setAttribute] = useState([]);
    const [attributeAll, setAttributeAll] = useState([]);
    const [idTread, setidTread] = useState('');
    const [shadow, setShadow] = useState(false);
    const containerRef = useRef();
    const [load, setLoad] = useState(true);
    const [load2, setLoad2] = useState(true);
    const [editCompany, setEditCompany] = useState(false);
    const [nameCompany, setNameCompany] = useState(GlobalState.singleCompain.name || '');
    const [descCompany, setDescCompany] = useState(GlobalState.singleCompain.description ||'');

    const [nameCompanyS, setNameCompanyS] = useState(GlobalState.singleCompain.name || '');
    const [descCompanyS, setDescCompanyS] = useState(GlobalState.singleCompain.description ||'');

    const [compain, setCompain] = useState([]);
    const textRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const [allText, setAllText] = useState(false);
    const [idError, setIdError] = useState(false);

    var flag_open = 0;


    const [listAttribute, setListAttribute]=useState([]);




    const setEditAddCompany = () =>{
               
        var item0 = [];
        var item2 = [];
        var flag = 0;
        compain?.segments?.map((x, id2)=>{
            flag=0
            item2 = [];
            listAttribute.map((i)=>
                x.name==i.namecheck?flag=1:undefined
            )
            if(flag==0){
                x.microSegments?.map((g, id3)=>
                    item2.push({name:g.name, count: g.count, check: g.isSelected})
                )
                item0.push({
                    name: x.name,
                    list: item2,
                    id_attr: x.attribute.id
                })
            }
        })
        var newItem = {
            namecheck:"", 
            open: false, 
            type: false, 
            list: item0,
            id: ''
        };
        setListAttribute(prev => [...prev, newItem]);
    }

    const openSelectAttr = (a)=>{
        setListAttribute(prev =>
            prev.map((item, index) => ({
            ...item,
            open: index === a ? !item.open : false
            }))
        );
    }

    const addSelectAttr = async(a, id) => {
        

        var select = [];
        var deselect = [];
       
            
        listAttribute.map((i)=>{
            if(i.id==id){
                i.list.map((t)=>{
                    if(t.id_attr==id){
                        console.log(t.list)
                        select = [];
                        deselect = [];
                        t.list.map((u)=>{
                            if(u.check){
                                select.push(u.name)
                            }
                            else{
                               deselect.push(u.name)
                            }
                        }
                        )
                    }
                })
            }
        })
        var param = {
            select: select,
            deselect: deselect
        };
        var token = localStorage.getItem("token");
        const response = await fetch(Domen.url + `strategy/campaigns/`+compain.id+`/segment/`+id+`/select`, {
            method: 'POST',
            headers: {
                'Authorization': token,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(param),
        })
        if(response.status>=200&&response.status<399)
        {
            const data = await response.json();
            if(data.status=="updated"){
                
                setListAttribute(prev =>
                    prev.map((item, index) =>
                    index === a
                        ? { ...item, type: true }
                        : item
                    )
                );
                GetSingleCompain();
            }
        }
    };

    const changeAttrSelect = (indexToUpdate, newName, id_attr)=>{
        setListAttribute(prev =>
            prev.map((item, index) =>
            index === indexToUpdate
                ? { ...item, namecheck: newName, id: id_attr }
                : item
            )
        );
        openSelectAttr(indexToUpdate);
    }

    const changeCheckListAttr = (i, j, k) => {
        setListAttribute(prev =>
            prev.map((item, indexI) => {
            if (indexI !== i) return item;

            const updatedList = item.list.map((group, indexJ) => {
                if (indexJ !== j) return group;

                const updatedInnerList = group.list.map((option, indexK) => {
                if (indexK !== k) return option;

                return {
                    ...option,
                    check: !option.check 
                };
                });

                return {
                ...group,
                list: updatedInnerList
                };
            });

            return {
                ...item,
                list: updatedList
            };
            })
        );
    };


    const isNotJson = (str) => {
        if (typeof str !== 'string') return true;
        try {
            JSON.parse(str);
            return false; // це валідний JSON
        } catch (e) {
            return true; // не JSON
        }
    };

    let source;
    const addmessages = async() =>{

        if(load){
            return;
        }

        if (source) {
            source.close(); // Закриваємо старий SSE, якщо існує
        }
        setLoad(true);
        setActivbut(false);
        var t = messages;
        t = [...t, {
            id:"",
            type:1,
            company:"",
            website:"",
            text:input,
            score:"",
            isNew: false,
        }];
        setMessages(t);

        setInput('');
        setTimeout(function(){
            setInput('');
            document.getElementById('textarea').style.height = '22px';
        },500)
        const el = containerRef.current;
        if (el) {
            el.scrollTop = el.scrollHeight+50;
        }

        var token = localStorage.getItem("token");

        var topic = "Company Profiles";
        if(activemenu==1){
            topic = "Company Profiles";
        }
        if(activemenu==2){
            topic = "Communication Guides";
        }
        if(activemenu==3){
            topic = "Portraits attributes";
        }

        var attr = {
            message:input,
            topic: topic,
        };
        var mes = allmessages;
        
        if(idTread!=undefined)
        {
            source = new SSE(Domen.url + 'agent/campaign/ask', {headers: {'Authorization': token,'Content-Type': 'application/json'}, payload: JSON.stringify(attr)});
        }
        else
        {
            source = new SSE(Domen.url + 'agent/campaign/ask', {headers: {'Authorization': token,'Content-Type': 'application/json'}, payload: JSON.stringify(attr)});
        }
        
        source.addEventListener('message', function(e) {
            if(e.data!='')
            {
                var payload = JSON.parse(e.data);

                if(payload.type=="message")
                {
                    if(payload.content.content=='')
                    {
                        var y = payload.content.tool_calls[0];
                        if( 
                            y?.name=='get_campaigns'||
                            y?.name=='create_campaign'||
                            y?.name=='update_campaign'||
                            y?.name=='delete_campaign'||
                            y?.name=='get_company_profile'||
                            y?.name=='update_company_profile'||
                            y?.name=='update_microsegment_selection'||
                            y?.name=='get_products'||
                            y?.name=='create_product'||
                            y?.name=='update_product'||
                            y?.name=='delete_product'||
                            y?.name=='get_tools'||
                            y?.name=='update_tool'||
                            y?.name=='create_tool'||

                            
                            y?.name=='delete_tool'
                           
                        ){
                            setActiveMenu(1);
                            getProfile();
                            getProfileProduct();
                            getProfileTools();
                            setLoad2(true);
                        }
                        else if( 
                            y?.name=='get_communication_guide'||
                            y?.name=='update_communication_guide'||
                            y?.name=='create_custom_rule'||
                            y?.name=='get_custom_rules'||
                            y?.name=='update_custom_rule'||
                            y?.name=='delete_custom_rule'||
                            y?.name=='create_letter_style'||
                            y?.name=='get_letter_styles'||
                            y?.name=='update_letter_style'||
                            y?.name=='delete_letter_style'
                           
                        ){
                            setActiveMenu(2);
                            getGuide();
                            setLoad2(true);
                        }
                        else if( 
                            y?.name=='get_attributes'||
                            y?.name=='delete_attribute'||
                            y?.name=='update_attribute'
                        ){
                            setActiveMenu(3)
                            setLoad2(true);
                        }
                        
                    }
                    if(payload.content.content!='')
                    {
                        if(payload.content.type=='ai')
                        {   
                            if(isNotJson(payload.content.content))
                            {
                                if(payload.content.type!="human")
                                {
                                    t = [...t, {
                                        id: payload.content.message_id,
                                        type:2,
                                        company:"",
                                        website:"",
                                        text:payload.content.content,
                                        score:null,
                                        isNew: true,
                                    }];
                                    setMessages(t);
                                    setLoad(false);
                                    setTimeout(function(){
                                        setLoad2(false)
                                    }, 3000)
                                }
                            }
                        }
                    }
                }
                setInput('');
                
                const el = containerRef.current;
                if (el) {
                    el.scrollTop = el.scrollHeight+50;
                }
                
                
            }
            
        });
        source.stream();
        setActivbut(false);
    }

   
    useEffect(() => {
        const el = containerRef.current;
        if (el) {
        el.scrollTop = el.scrollHeight;
        }
    }, [messages]);


    const handleKeyDown = (e) => {
        if (e.key === 'Enter'&&input!='') {
            if (e.shiftKey) 
            {
                return;
            } 
            else 
            {
                const cleanedText = input.replace(/\n/g, ' ');
                setInput(cleanedText);
                addmessages();
                
            }
        }
        setActivbut(false);
    };
    
    const LikeMes = async(id)=>{
        var token = localStorage.getItem("token");
       
        var param = {
            score : 5
        };
        const response = await fetch(Domen.url + `agent/company-profile/feedback/`+id, {
            method: 'POST',
            headers: {
                'Authorization': token,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(param),
        })
        if(response.status>=200&&response.status<399)
        {
            const data = await response.json();
            getHistory();
        }
    }

    const DisLikeMes = async(id)=>{
     
        var token = localStorage.getItem("token");
        var param = {
            score : 0
        };
        const response = await fetch(Domen.url + `agent/company-profile/feedback/`+id, {
            method: 'POST',
            headers: {
                'Authorization': token,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(param),
        })
        if(response.status>=200&&response.status<399)
        {
            const data = await response.json();
            getHistory();
        }
    }

    const getHistory = async()=>{
        var token = localStorage.getItem("token");
        var t = [];
        const response = await fetch(Domen.url + `agent/campaign/history`, {
                method: 'GET',
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            if(response.status=="200")
            {
                const data = await response.json();
            

                setidTread(data.id);


                data?.messages?.map((n)=>{
                    n.versions?.map((c)=>{
                        t = [...t, {
                            id:n.id,
                            type:1,
                            company:"",
                            website:"",
                            text:c.text,
                            isNew: false,
                        }];
                        t = [...t, {
                            id:n.id,
                            type:2,
                            company:"",
                            website:"",
                            text:c.response,
                            score:c.score,
                            isNew: false
                        }];
                    })
                    
                })

                
                setMessages(t);
                setLoad(false);
                setLoad2(false);
            } 
    }

    const getAttribute = async()=>{
        var token = localStorage.getItem("token");
        var t = messages;
        const response = await fetch(Domen.url + `portraits/table`, {
                method: 'GET',
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            if(response.status=="200")
            {
                const data = await response.json();
                var mass = [];
                data.data?.map((f)=>
                    mass = [...mass, {id: f.id, name: f.name, description: f.description, check1: f.segment, check2: f.dynamicField}]
                )
                setAttribute(mass);
                setAttributeAll(data);
                
            } 
    }

    const setInput0 = (e)=>{
        setInput(e.target.value);
        if(e.target.value!='')
        {
            setActivbut(true)
        }
        else{
            setActivbut(false)
        }
    }

    useEffect(() => {
        if (editorRef.current) {
            editorRef.current.focus();
        }
    }, [editor1]);
   
    const handleSelection = () => {
        const selection = window.getSelection();
        const selectedText = selection.toString().trim();
        setIsTextSelected(!!selectedText); // Якщо є виділений текст, показуємо блок
    };
    
    function autoGrow(el) {
        el.style.height = '1px';
        el.style.height = el.scrollHeight + 'px';
    }

    useEffect(()=>{

        getAttribute();



        document.getElementById('textarea').addEventListener('input', function() {
            autoGrow(this);
        });
        if(document.getElementsByClassName("textareas")[0])
        {
            document.getElementsByClassName("textareas")[0].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        if(document.getElementsByClassName("textareas")[1])
        {
            document.getElementsByClassName("textareas")[1].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        if(document.getElementsByClassName("textareas")[2])
        {
            document.getElementsByClassName("textareas")[2].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        if(document.getElementsByClassName("textareas")[3])
        {
            document.getElementsByClassName("textareas")[3].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        if(document.getElementsByClassName("textareas")[4])
        {
            document.getElementsByClassName("textareas")[4].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        if(document.getElementsByClassName("textareas")[5])
        {
            document.getElementsByClassName("textareas")[5].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        if(document.getElementsByClassName("textareas")[6])
        {
            document.getElementsByClassName("textareas")[6].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        if(document.getElementsByClassName("textareas")[7])
        {
            document.getElementsByClassName("textareas")[7].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        if(document.getElementsByClassName("textareas")[8])
        {
            document.getElementsByClassName("textareas")[8].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        if(document.getElementsByClassName("textareas")[9])
        {
            document.getElementsByClassName("textareas")[9].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        if(document.getElementsByClassName("textareas")[10])
        {
            document.getElementsByClassName("textareas")[10].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        if(document.getElementsByClassName("textareas")[11])
        {
            document.getElementsByClassName("textareas")[11].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        
        var ld = window.document.getElementById('messages');
        var cw = ld.offsetWidth;
        var w = window.innerWidth
        
        window.document.getElementById('messages').style.width = "50%";
        window.document.getElementById('controls').style.width = "50%";


        addEventListener("mousemove", (e) => {
            var change = cw + (e.clientX - cw - 40);
            var max = w - 854;
            if(unlock) {
               
                if(change > 575 && change<max) {
                   
                    var t = w - change;
                    window.document.getElementById('messages').style.width = change+"px";
                    window.document.getElementById('controls').style.width = t+"px";
                }
                
                
            }
        });
        ref.current.addEventListener("mousedown", ()=>{
            unlock = true;
        });

        addEventListener("mousedown", (e)=>{
            if(unlock) {
                e.preventDefault();
            }
        });

        addEventListener("mouseup", ()=>{
            unlock = false;
        });
        
        

    },[])

    const getProfile = async() =>{
        var token = localStorage.getItem("token");
        const response = await fetch(Domen.url + `company_profile/`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response.status>=200&&response.status<399)
        {
            const data = await response.json();
            setProfile(data); 
            setProfileName(data.name);
            setProfileWeb(data.website);
            setProfileDesc(data.description);
            setProfileId(data.id);
            setTimeout(function(){
                setLoad2(false)
            }, 3000)
        }
        else
        {
            alert(response.status)
        }
    }

    const getProfileProduct = async() =>{
        var token = localStorage.getItem("token");
        const response = await fetch(Domen.url + `company_profile/products/`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response.status>=200&&response.status<399)
        {
            const data = await response.json();
            const withCheck = data.map(item => ({ ...item, check: false }));
            setProducts(withCheck);
        }
        else
        {
            alert(response.status)
        }
    }

    const getProfileTools = async() =>{
        var token = localStorage.getItem("token");
        const response = await fetch(Domen.url + `company_profile/tools/`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response.status>=200&&response.status<399)
        {
            const data = await response.json();
            const withCheck = data.map(item => ({ ...item, check: false }));
            setToolsProfile(withCheck);
        }
        else
        {
            alert(response.status)
        }
    }

    const getGuide = async() =>{
        var token = localStorage.getItem("token");
        var t = [];
        const response = await fetch(Domen.url + `company_profile/communication-guide`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response.status>=200&&response.status<399)
        {
            const data = await response.json();
            setGuide(data); 
            setGuideToneOfVoice(data.toneOfVoice);
            setGuidespamWord(data.spamWord);
            setGuidelimitation(data.limitation);
            const updatedLetterStyle = data.letterStyle?.map((t) => ({...t,
                description: t.description, 
                id: t.id, 
                name: t.name, 
                updatedAt: t.updatedAt, 
                check:false
            }))
            
            setLetterProfile(updatedLetterStyle || []);
            setLoad2(false);
        }
        else
        {
            alert(response.status)
        }
    }


    useEffect(()=>{
        getHistory();
    },[])

    
    const setActiveMenu0 = (a)=>{
        setActiveMenu(a);


        setmorefunck(false);
    }

    const copyMessage = (text)=>{
        navigator.clipboard.writeText(text)
        .then(() => {
            console.log("Текст скопійовано!");
        })
        .catch(err => {
            console.error("Помилка копіювання:", err);
        });
    }

    useEffect(() => {
        const el = textRef.current;
        if (el) {
        const isClamped = el.scrollHeight > el.clientHeight + 1;
        setIsOverflowing(isClamped);
        }
    }, [editCompany]);


    const editCompain = async() =>{
        var newlocal = nameCompany.trim();
        var newdesk = descCompany.trim();
        setNameCompany(newlocal);
        setDescCompany(newdesk);
        var token = localStorage.getItem("token");
        var param = {
            "name": newlocal,
            "description": newdesk
        };
        const response = await fetch(Domen.url + `strategy/goals/`+compain.goalId+`/campaigns/`+compain.id, {
            method: 'PUT',
            headers: {
                'Authorization': token,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(param),
        })
        
        if(response.status=="200")
        {
            const data = await response.json();
            setEditCompany(false);
        } 
        else{
            setIdError(true)
        }
    }


    const GetSingleCompain = async()=>{
        var token = localStorage.getItem("token");
       

        const response = await fetch(Domen.url + `strategy/`+goal+`/campaign/`+comp, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response.status>=200&&response.status<399)
        {
            const data = await response.json();

            // if(data.status=="Done")
            // {
                setNameCompany(data.name)
                setDescCompany(data.description)
                setCompain(data);
                var newItem = {};
                var item0 = [];
                var item2 = [];
                setListAttribute([]);
                changeSingleCompain(data)
                data?.segments?.forEach(n => {
                    if (n.isSelected) {
                        const item2 = n.microSegments?.map(g => ({
                            name: g.name,
                            count: g.count,
                            check: g.isSelected
                        })) || [];

                        const newItem = {
                            namecheck: n.name,
                            open: false,
                            type: true,
                            list: [{
                                name: n.name,
                                id_attr: n.attribute.id,
                                list: item2
                            }],
                            id: n.attribute.id
                        };

                        // Перевірка на дубль
                        setListAttribute(prev => prev.some(x => x.id === newItem.id) ? prev : [...prev, newItem]);
                    }
                });
                const el = textRef.current;
                if (el) {
                const isClamped = el.scrollHeight > el.clientHeight + 1;
                setIsOverflowing(isClamped);
                
                }
                setEditCompany(false);
            // }
            // else if(data.status=="Draft")
            // {
            //     setNameCompany(data.name)
            //     setDescCompany(data.description)
            //     setCompain(data);
            //     var newItem = {};
            //     var item0 = [];
            //     var item2 = [];
            //     setListAttribute([]);
            //     data?.segments?.forEach(n => {
            //         if (n.isSelected) {
            //             const item2 = n.microSegments?.map(g => ({
            //                 name: g.name,
            //                 count: g.count,
            //                 check: g.isSelected
            //             })) || [];

            //             const newItem = {
            //                 namecheck: n.name,
            //                 open: false,
            //                 type: true,
            //                 list: [{
            //                     name: n.name,
            //                     id_attr: n.attribute.id,
            //                     list: item2
            //                 }],
            //                 id: n.attribute.id
            //             };

            //             // Перевірка на дубль
            //             setListAttribute(prev => prev.some(x => x.id === newItem.id) ? prev : [...prev, newItem]);
            //         }
            //     });
            //     const el = textRef.current;
            //     if (el) {
            //     const isClamped = el.scrollHeight > el.clientHeight + 1;
            //     setIsOverflowing(isClamped);
            //     }
            // }
            // else if(data.status=="In Progress")
            // {
            //     setNameCompany(data.name)
            //     setDescCompany(data.description)
            //     setCompain(data);
            //     var newItem = {};
            //     var item0 = [];
            //     var item2 = [];
            //     setListAttribute([]);
            //     data?.segments?.forEach(n => {
            //         if (n.isSelected) {
            //             const item2 = n.microSegments?.map(g => ({
            //                 name: g.name,
            //                 count: g.count,
            //                 check: g.isSelected
            //             })) || [];

            //             const newItem = {
            //                 namecheck: n.name,
            //                 open: false,
            //                 type: true,
            //                 list: [{
            //                     name: n.name,
            //                     id_attr: n.attribute.id,
            //                     list: item2
            //                 }],
            //                 id: n.attribute.id
            //             };

            //             // Перевірка на дубль
            //             setListAttribute(prev => prev.some(x => x.id === newItem.id) ? prev : [...prev, newItem]);
            //         }
            //     });
            //     const el = textRef.current;
            //     if (el) {
            //     const isClamped = el.scrollHeight > el.clientHeight + 1;
            //     setIsOverflowing(isClamped);
            //     }
            // }
            // else{
            //     setTimeout(GetSingleCompain, 5000);
            // }
            
        }
    }

    
    useEffect(() => {
        GetSingleCompain();
    },[])

    const setNameCompany0 = (d) =>{
        setNameCompany(d);
        setIdError(false);
    }

    const deleteCompain = async(id_comp)=>{
        var select = [];
        var deselect = [];
       
            
        listAttribute.map((i)=>{
            if(i.id==id_comp){
                i.list.map((t)=>{
                    if(t.id_attr==id_comp){

                        select = [];
                        deselect = [];
                        t.list.map((u)=>{
                            deselect.push(u.name)
                        }
                        )
                    }
                })
            }
        })
        var param = {
            select: select,
            deselect: deselect
        };
        var token = localStorage.getItem("token");
        const response = await fetch(Domen.url + `strategy/campaigns/`+compain.id+`/segment/`+id_comp+`/select`, {
            method: 'POST',
            headers: {
                'Authorization': token,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(param),
        })
        if(response.status>=200&&response.status<399)
        {
            const data = await response.json();
            if(data.status=="updated"){
                GetSingleCompain();
            }
        } 
    }

    // const editToolComp = async(id_attr)=>{
    //     console.log(id_attr)
    //     setListAttribute(prev =>
    //         prev.map((item, index) =>
    //         index === id_attr
    //             ? { ...item, open: true }
    //             : item
    //         )
    //     );
    //     console.log(listAttribute);
    // }

    const editToolComp = (id_attr) => {
        setListAttribute(prev =>
            prev.map((item, index) =>
                index === id_attr
                ? { ...item, open: false, type: false }
                : item
            )
        );
    };
    const closeToolComp = async() => {
        setNameCompany0(nameCompanyS);
        setDescCompany(descCompanyS);
        GetSingleCompain();
    };

    const setEditCompany0 = (f) => {
        

        GetSingleCompain();
        
    }
    
    const isAddInactive = listAttribute.length > 0 && listAttribute.some(item => item.namecheck === "");
    return (
        <>
            <div className='assistant_page' onClick={()=>handleSelection()}>
                <div id="messages" className='assistant_messages'>
                    <div className='assistant_logo'>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="40" height="40" rx="4" fill="#020202"/>
                            <path d="M20.1489 34.4348C19.1377 34.4738 18.1137 34.1095 17.3418 33.342C16.6919 32.6959 16.3295 31.8723 16.2545 31.0282C15.5941 26.0169 14.0322 24.4611 8.99626 23.8034C8.1443 23.7305 7.31256 23.3699 6.66058 22.7217C5.19127 21.2609 5.19127 18.8924 6.66058 17.4316C8.12989 15.9707 10.5121 15.9707 11.9814 17.4316C12.5957 18.0423 12.9531 18.8116 13.0538 19.6069L13.0559 19.6049C13.3176 21.6648 13.7243 23.1512 14.4481 24.2353C15.4438 25.9142 17.5653 27.0735 20.0215 27.0735C22.6513 27.0735 24.8973 25.7446 25.7889 23.8718C26.3582 22.8543 26.7033 21.5204 26.9363 19.7585C27.009 18.9103 27.3718 18.082 28.0246 17.4329C29.494 15.9721 31.8762 15.9721 33.3455 17.4329C34.8148 18.8938 34.8148 21.2622 33.3455 22.723C32.7315 23.3335 31.9581 23.6889 31.1585 23.7891L31.1598 23.7905C25.9638 24.4431 24.396 26.0019 23.7396 31.1678L23.7383 31.1665C23.6376 31.9618 23.2801 32.7311 22.6659 33.3418C21.9677 34.036 21.0634 34.4003 20.1489 34.4348Z" fill="#F8CD02"/>
                            <path d="M17.4939 22.2646C15.8822 20.7278 15.8822 18.2362 17.4939 16.6995C19.1056 15.1627 21.7187 15.1627 23.3304 16.6995C24.942 18.2362 24.942 20.7278 23.3304 22.2646C21.7187 23.8014 19.1056 23.8014 17.4939 22.2646Z" fill="white"/>
                            <g clip-path="url(#clip0_1473_1721)">
                            <path d="M13.8656 11.0263C12.177 10.7671 11.9464 10.5826 11.6223 9.23168C11.6177 9.21265 11.605 9.19549 11.5863 9.18315C11.5677 9.17081 11.5442 9.16406 11.52 9.16406C11.4958 9.16406 11.4723 9.17081 11.4536 9.18315C11.4349 9.19549 11.4222 9.21265 11.4177 9.23168C11.0937 10.5826 10.8631 10.7671 9.17436 11.0263C9.15058 11.03 9.12913 11.0401 9.11371 11.0551C9.09828 11.07 9.08984 11.0888 9.08984 11.1082C9.08984 11.1275 9.09828 11.1463 9.11371 11.1613C9.12913 11.1762 9.15058 11.1864 9.17436 11.19C10.8631 11.4493 11.0937 11.6338 11.4177 12.9847C11.4223 13.0037 11.435 13.0208 11.4536 13.0331C11.4723 13.0455 11.4958 13.0522 11.52 13.0522C11.5442 13.0522 11.5676 13.0455 11.5863 13.0331C11.605 13.0208 11.6177 13.0037 11.6223 12.9847C11.9464 11.6338 12.177 11.4493 13.8656 11.19C13.8894 11.1864 13.9108 11.1762 13.9262 11.1613C13.9417 11.1463 13.9501 11.1275 13.9501 11.1082C13.9501 11.0888 13.9417 11.07 13.9262 11.0551C13.9108 11.0401 13.8894 11.03 13.8656 11.0263Z" fill="#FFCC00"/>
                            </g>
                            <g clip-path="url(#clip1_1473_1721)">
                            <path d="M31.6507 11.0263C29.9621 10.7671 29.7315 10.5826 29.4074 9.23168C29.4029 9.21265 29.3902 9.19549 29.3715 9.18315C29.3528 9.17081 29.3294 9.16406 29.3051 9.16406C29.2809 9.16406 29.2574 9.17081 29.2388 9.18315C29.2201 9.19549 29.2074 9.21265 29.2028 9.23168C28.8788 10.5826 28.6482 10.7671 26.9595 11.0263C26.9357 11.03 26.9143 11.0401 26.8989 11.0551C26.8834 11.07 26.875 11.0888 26.875 11.1082C26.875 11.1275 26.8834 11.1463 26.8989 11.1613C26.9143 11.1762 26.9357 11.1864 26.9595 11.19C28.6482 11.4493 28.8788 11.6338 29.2028 12.9847C29.2074 13.0037 29.2201 13.0208 29.2388 13.0331C29.2575 13.0455 29.2809 13.0522 29.3051 13.0522C29.3293 13.0522 29.3528 13.0455 29.3715 13.0331C29.3901 13.0208 29.4029 13.0037 29.4074 12.9847C29.7315 11.6338 29.9621 11.4493 31.6507 11.19C31.6745 11.1864 31.696 11.1762 31.7114 11.1613C31.7268 11.1463 31.7353 11.1275 31.7353 11.1082C31.7353 11.0888 31.7268 11.07 31.7114 11.0551C31.696 11.0401 31.6745 11.03 31.6507 11.0263Z" fill="#FFCC00"/>
                            </g>
                            <g clip-path="url(#clip2_1473_1721)">
                            <path d="M24.6354 8.71669C21.5959 8.19818 21.1808 7.82924 20.5975 5.12742C20.5892 5.08936 20.5663 5.05505 20.5327 5.03037C20.4991 5.00569 20.4569 4.99219 20.4133 4.99219C20.3697 4.99219 20.3275 5.00569 20.2939 5.03037C20.2602 5.05505 20.2374 5.08936 20.2291 5.12742C19.6459 7.82924 19.2309 8.19818 16.1912 8.71669C16.1484 8.72401 16.1098 8.74436 16.082 8.77423C16.0542 8.80411 16.0391 8.84165 16.0391 8.8804C16.0391 8.91915 16.0542 8.95669 16.082 8.98657C16.1098 9.01645 16.1484 9.03679 16.1912 9.04411C19.2309 9.56264 19.6459 9.93156 20.2291 12.6334C20.2374 12.6714 20.2603 12.7057 20.2939 12.7303C20.3275 12.755 20.3697 12.7685 20.4133 12.7685C20.4569 12.7685 20.4991 12.755 20.5327 12.7303C20.5663 12.7057 20.5892 12.6714 20.5975 12.6334C21.1808 9.93156 21.5959 9.56264 24.6354 9.04411C24.6782 9.03679 24.7168 9.01645 24.7446 8.98657C24.7723 8.95669 24.7875 8.91915 24.7875 8.8804C24.7875 8.84165 24.7723 8.80411 24.7446 8.77423C24.7168 8.74436 24.6782 8.72401 24.6354 8.71669Z" fill="#FFCC00"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_1473_1721">
                            <rect width="5.55556" height="4.44444" fill="white" transform="translate(8.74219 8.88281)"/>
                            </clipPath>
                            <clipPath id="clip1_1473_1721">
                            <rect width="5.55556" height="4.44444" fill="white" transform="translate(26.5273 8.88281)"/>
                            </clipPath>
                            <clipPath id="clip2_1473_1721">
                            <rect width="10" height="8.88889" fill="white" transform="translate(15.4141 4.4375)"/>
                            </clipPath>
                            </defs>
                        </svg>
                        {langv?.assistant?.ai_assistant}
                    </div>
                    <div className='assistant_messages_body' ref={containerRef}>
                        {
                            messages?.map((n, id)=>
                                n.type==1?
                                <div className='clientmess_line'>
                                    <div className='clientmess'>
                                        {/* <div className='clientmess_icons' onClick={()=>setActivemess(!activemess)}>
                                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11.5436 6.44542L5.59914 12.3903C5.42046 12.569 5.29715 12.7954 5.24402 13.0424L4.75839 15.2988C4.74521 15.36 4.74759 15.4236 4.76531 15.4837C4.78303 15.5438 4.81553 15.5985 4.85983 15.6428C4.90414 15.6872 4.95885 15.7197 5.01895 15.7374C5.07905 15.7551 5.14263 15.7575 5.20389 15.7443L7.46589 15.2568C7.71274 15.2037 7.93904 15.0805 8.11764 14.902L14.73 8.28967C15.0561 7.95461 15.2372 7.50463 15.234 7.03709C15.2308 6.56955 15.0437 6.12206 14.7131 5.79145C14.3825 5.46085 13.935 5.27371 13.4675 5.27055C12.9999 5.26738 12.5499 5.44844 12.2149 5.77454L11.5665 6.42254L11.5436 6.44542ZM12.48 6.03967C12.7443 5.78179 13.0996 5.63845 13.4689 5.64073C13.8381 5.643 14.1916 5.7907 14.4527 6.05181C14.7139 6.31293 14.8616 6.66642 14.8638 7.03568C14.8661 7.40495 14.7228 7.76023 14.4649 8.02454L13.938 8.55142L11.9531 6.56654L12.48 6.03967ZM11.6873 6.83167L13.6721 8.81654L7.85214 14.6365C7.72457 14.7642 7.56285 14.8524 7.38639 14.8904L5.12477 15.3779L5.61002 13.1212C5.64804 12.9447 5.7362 12.783 5.86389 12.6554L11.6873 6.83167Z" fill="#8E8E93"/>
                                            </svg>
                                        </div> */}
                                        <div className='clientmess_text'>
                                            <p dangerouslySetInnerHTML={{__html: n.text}}></p>
                                            {
                                                activemess?
                                            
                                                <div className='clientmess_text_buts'>
                                                    <div className='clientmess_text_buts_col'>
                                                        <div className='clientmess_text_but' onClick={()=>setActivemess(!activemess)}>
                                                            {langv?.assistant?.cancel}
                                                        </div>
                                                        <div className='clientmess_text_but b_y'>
                                                            {langv?.assistant?.send}
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <></>
                                            }
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className='adminmess_line'>
                                    <div className='adminmess'>
                                        <div className='admin_icons' >
                                            <img src={logoeditor} alt=""/>
                                        </div>
                                        <div className='admin_text'>
                                            <div className='admin_text_h'>{langv?.assistant?.general}:</div>
                                            {
                                                n.company!=""?
                                                <span>{n.company}</span>
                                                :
                                                <></>
                                            }
                                            {
                                                n.website!=""?
                                                <span>{n.website}</span>
                                                :
                                                <></>
                                            }
                                            
                                            
                                            <br/>
                                             <MarkdownRenderer text={n.text} />
                                            {/* {
                                                messages.length==(id+1)&&n.isNew?
                                                <Typewriter text={n.text} speed={2} ref={containerRef} pauseDuration={400} paragraphPause={700}/>
                                                :
                                                isMarkdownTable(n.text)
                                                ? <MarkdownTable key={idx} markdown={n.text} />
                                                : <p dangerouslySetInnerHTML={{__html:n.text}}></p>
                                            } */}
                                            
                                            <div className='icon_admin_hover_line'>
                                                <div className='icon_admin_hover'>
                                                    <div className='like'>
                                                        <span className='tolpipa_icon'> {langv?.strategy?.field2}</span>
                                                        <svg onClick={()=>copyMessage(n.text)} className='def_like' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M11.6667 6.5H6.33333C5.59695 6.5 5 6.96494 5 7.53846V14.4615C5 15.0351 5.59695 15.5 6.33333 15.5H11.6667C12.403 15.5 13 15.0351 13 14.4615V7.53846C13 6.96494 12.403 6.5 11.6667 6.5Z" stroke="#8E8E93" stroke-width="0.7"/>
                                                            <path d="M7 5.53846C7 5.26304 7.14048 4.99891 7.39052 4.80416C7.64057 4.60941 7.97971 4.5 8.33333 4.5H13.6667C14.0203 4.5 14.3594 4.60941 14.6095 4.80416C14.8595 4.99891 15 5.26304 15 5.53846V12.4615C15 12.737 14.8595 13.0011 14.6095 13.1958C14.3594 13.3906 14.0203 13.5 13.6667 13.5" stroke="#8E8E93" stroke-width="0.7"/>
                                                        </svg>
                                                        <svg onClick={()=>copyMessage(n.text)} className='hov_like' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <rect width="20" height="20" rx="4" fill="#E5E5EA"/>
                                                            <path d="M11.6667 6.5H6.33333C5.59695 6.5 5 6.96494 5 7.53846V14.4615C5 15.0351 5.59695 15.5 6.33333 15.5H11.6667C12.403 15.5 13 15.0351 13 14.4615V7.53846C13 6.96494 12.403 6.5 11.6667 6.5Z" stroke="#8E8E93" stroke-width="0.7"/>
                                                            <path d="M7 5.53846C7 5.26304 7.14048 4.99891 7.39052 4.80416C7.64057 4.60941 7.97971 4.5 8.33333 4.5H13.6667C14.0203 4.5 14.3594 4.60941 14.6095 4.80416C14.8595 4.99891 15 5.26304 15 5.53846V12.4615C15 12.737 14.8595 13.0011 14.6095 13.1958C14.3594 13.3906 14.0203 13.5 13.6667 13.5" stroke="#8E8E93" stroke-width="0.7"/>
                                                        </svg>

                                                    </div>
                                                    <div className='like'>
                                                        <span className='tolpipa_icon'>{langv?.strategy?.field3}</span>
                                                    {
                                                        n.score==5?
                                                        <svg className='def_like' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <rect width="20" height="20" rx="4" fill="#F2F2F7"/>
                                                            <path d="M5.74609 9.60652L10.5089 8.86719H13.2773V14.0518H5.74609V9.60652Z" fill="#AEAEB2"/>
                                                            <path d="M7.01899 9.58333C7.46676 9.58333 7.87065 9.33556 8.14732 8.98333C8.57809 8.43265 9.11956 7.97843 9.73676 7.65C10.1384 7.43667 10.4868 7.11889 10.6551 6.69722C10.7733 6.4018 10.834 6.08653 10.834 5.76833V5.41667C10.834 5.30616 10.8779 5.20018 10.956 5.12204C11.0342 5.0439 11.1401 5 11.2507 5C11.5822 5 11.9001 5.1317 12.1345 5.36612C12.369 5.60054 12.5007 5.91848 12.5007 6.25C12.5007 6.89 12.3562 7.49611 12.099 8.03778C11.9512 8.34778 12.1584 8.75 12.5018 8.75M12.5018 8.75H14.2384C14.8084 8.75 15.319 9.13556 15.3795 9.70278C15.4047 9.93722 15.4173 10.1752 15.4173 10.4167C15.4196 11.9369 14.9001 13.4118 13.9457 14.595C13.7301 14.8628 13.3973 15 13.054 15H10.8229C10.5542 15.0002 10.2873 14.957 10.0323 14.8722L8.30232 14.2944C8.04738 14.2096 7.78044 14.1665 7.51176 14.1667H6.61399M12.5018 8.75H11.2507H12.5018ZM6.61399 14.1667C6.66028 14.2804 6.71028 14.3919 6.76399 14.5011C6.87343 14.7233 6.72065 15 6.47343 15H5.96899C5.4751 15 5.01732 14.7122 4.87343 14.24C4.68101 13.6085 4.58346 12.9519 4.58399 12.2917C4.58399 11.4289 4.74788 10.605 5.04565 9.84833C5.21565 9.41833 5.64899 9.16667 6.11176 9.16667H6.69676C6.95899 9.16667 7.11065 9.47556 6.97454 9.7C6.50009 10.4811 6.24984 11.3778 6.25121 12.2917C6.25072 12.9342 6.37352 13.5708 6.61399 14.1667Z" fill="#AEAEB2"/>
                                                            <path d="M7.01899 9.58333C7.46676 9.58333 7.87065 9.33556 8.14732 8.98333C8.57809 8.43265 9.11956 7.97843 9.73676 7.65C10.1384 7.43667 10.4868 7.11889 10.6551 6.69722C10.7733 6.4018 10.834 6.08653 10.834 5.76833V5.41667C10.834 5.30616 10.8779 5.20018 10.956 5.12204C11.0342 5.0439 11.1401 5 11.2507 5C11.5822 5 11.9001 5.1317 12.1345 5.36612C12.369 5.60054 12.5007 5.91848 12.5007 6.25C12.5007 6.89 12.3562 7.49611 12.099 8.03778C11.9512 8.34778 12.1584 8.75 12.5018 8.75M12.5018 8.75H14.2384C14.8084 8.75 15.319 9.13556 15.3795 9.70278C15.4047 9.93722 15.4173 10.1752 15.4173 10.4167C15.4196 11.9369 14.9001 13.4118 13.9457 14.595C13.7301 14.8628 13.3973 15 13.054 15H10.8229C10.5542 15.0002 10.2873 14.957 10.0323 14.8722L8.30232 14.2944C8.04738 14.2096 7.78044 14.1665 7.51176 14.1667H6.61399M12.5018 8.75H11.2507M6.61399 14.1667C6.66028 14.2804 6.71028 14.3919 6.76399 14.5011C6.87343 14.7233 6.72065 15 6.47343 15H5.96899C5.4751 15 5.01732 14.7122 4.87343 14.24C4.68101 13.6085 4.58346 12.9519 4.58399 12.2917C4.58399 11.4289 4.74788 10.605 5.04565 9.84833C5.21565 9.41833 5.64899 9.16667 6.11176 9.16667H6.69676C6.95899 9.16667 7.11065 9.47556 6.97454 9.7C6.50009 10.4811 6.24984 11.3778 6.25121 12.2917C6.25072 12.9342 6.37352 13.5708 6.61399 14.1667Z" stroke="#8E8E93" stroke-width="0.583333" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                        :
                                                        <svg className='def_like' width="20" height="20" onClick={()=>LikeMes(n.id)} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M7.02094 9.58333C7.46872 9.58333 7.87261 9.33556 8.14927 8.98333C8.58004 8.43265 9.12151 7.97843 9.73872 7.65C10.1404 7.43667 10.4887 7.11889 10.6571 6.69722C10.7753 6.4018 10.836 6.08653 10.8359 5.76833V5.41667C10.8359 5.30616 10.8798 5.20018 10.958 5.12204C11.0361 5.0439 11.1421 5 11.2526 5C11.5841 5 11.9021 5.1317 12.1365 5.36612C12.3709 5.60054 12.5026 5.91848 12.5026 6.25C12.5026 6.89 12.3582 7.49611 12.1009 8.03778C11.9532 8.34778 12.1604 8.75 12.5037 8.75M12.5037 8.75H14.2404C14.8104 8.75 15.3209 9.13556 15.3815 9.70278C15.4067 9.93722 15.4193 10.1752 15.4193 10.4167C15.4216 11.9369 14.9021 13.4118 13.9476 14.595C13.7321 14.8628 13.3993 15 13.0559 15H10.8248C10.5562 15.0002 10.2892 14.957 10.0343 14.8722L8.30427 14.2944C8.04933 14.2096 7.78239 14.1665 7.51372 14.1667H6.61594C6.66224 14.2804 6.71224 14.3919 6.76594 14.5011C6.87538 14.7233 6.72261 15 6.47538 15H5.97094C5.47705 15 5.01927 14.7122 4.87538 14.24C4.68296 13.6085 4.58542 12.9519 4.58594 12.2917C4.58594 11.4289 4.74983 10.605 5.04761 9.84833C5.21761 9.41833 5.65094 9.16667 6.11372 9.16667H6.69872C6.96094 9.16667 7.11261 9.47556 6.9765 9.7C6.50204 10.4811 6.25179 11.3778 6.25316 12.2917C6.25267 12.9342 6.37603 13.5708 6.6165 14.1667M12.5037 8.75H11.2526" stroke="#8E8E93" stroke-width="0.583333" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                    }
                                                        <svg className='hov_like' onClick={()=>LikeMes(n.id)} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <rect width="20" height="20" rx="4" fill="#E5E5EA"/>
                                                            <path d="M7.01899 9.58333C7.46676 9.58333 7.87065 9.33556 8.14732 8.98333C8.57809 8.43265 9.11956 7.97843 9.73676 7.65C10.1384 7.43667 10.4868 7.11889 10.6551 6.69722C10.7733 6.4018 10.834 6.08653 10.834 5.76833V5.41667C10.834 5.30616 10.8779 5.20018 10.956 5.12204C11.0342 5.0439 11.1401 5 11.2507 5C11.5822 5 11.9001 5.1317 12.1345 5.36612C12.369 5.60054 12.5007 5.91848 12.5007 6.25C12.5007 6.89 12.3562 7.49611 12.099 8.03778C11.9512 8.34778 12.1584 8.75 12.5018 8.75M12.5018 8.75H14.2384C14.8084 8.75 15.319 9.13556 15.3795 9.70278C15.4047 9.93722 15.4173 10.1752 15.4173 10.4167C15.4196 11.9369 14.9001 13.4118 13.9457 14.595C13.7301 14.8628 13.3973 15 13.054 15H10.8229C10.5542 15.0002 10.2873 14.957 10.0323 14.8722L8.30232 14.2944C8.04738 14.2096 7.78044 14.1665 7.51176 14.1667H6.61399C6.66028 14.2804 6.71028 14.3919 6.76399 14.5011C6.87343 14.7233 6.72065 15 6.47343 15H5.96899C5.4751 15 5.01732 14.7122 4.87343 14.24C4.68101 13.6085 4.58346 12.9519 4.58399 12.2917C4.58399 11.4289 4.74788 10.605 5.04565 9.84833C5.21565 9.41833 5.64899 9.16667 6.11176 9.16667H6.69676C6.95899 9.16667 7.11065 9.47556 6.97454 9.7C6.50009 10.4811 6.24984 11.3778 6.25121 12.2917C6.25072 12.9342 6.37408 13.5708 6.61454 14.1667M12.5018 8.75H11.2507" stroke="#8E8E93" stroke-width="0.583333" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                    </div>
                                                    <div className='like'>
                                                        <span className='tolpipa_icon'>{langv?.strategy?.field4}</span>
                                                    {
                                                        n.score==0?
                                                        <svg className='def_like' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <rect x="20" y="20" width="20" height="20" rx="4" transform="rotate(180 20 20)" fill="#F2F2F7"/>
                                                            <path d="M5.74609 6.60652L10.8301 5.86719H13.7852V11.0518L13.0115 10.5447L9.10809 11.0518H5.74609V6.60652Z" fill="#AEAEB2"/>
                                                            <path d="M12.981 10.4167C12.5332 10.4167 12.1293 10.6644 11.8527 11.0167C11.4219 11.5673 10.8804 12.0216 10.2632 12.35C9.86157 12.5633 9.51324 12.8811 9.3449 13.3028C9.2267 13.5982 9.16599 13.9135 9.16601 14.2317V14.5833C9.16601 14.6938 9.12211 14.7998 9.04397 14.878C8.96583 14.9561 8.85985 15 8.74935 15C8.41783 15 8.09988 14.8683 7.86546 14.6339C7.63104 14.3995 7.49935 14.0815 7.49935 13.75C7.49935 13.11 7.64379 12.5039 7.90101 11.9622C8.04879 11.6522 7.84157 11.25 7.49823 11.25M7.49823 11.25H5.76157C5.19157 11.25 4.68101 10.8644 4.62046 10.2972C4.59527 10.0628 4.58268 9.82482 4.58268 9.58333C4.58038 8.06314 5.09987 6.58821 6.05435 5.405C6.2699 5.13722 6.60268 5 6.94601 5H9.17712C9.4458 4.99984 9.71274 5.04298 9.96768 5.12778L11.6977 5.70556C11.9526 5.79035 12.2196 5.8335 12.4882 5.83333H13.386M7.49823 11.25H8.74935H7.49823ZM13.386 5.83333C13.3397 5.71963 13.2897 5.60815 13.236 5.49889C13.1266 5.27667 13.2793 5 13.5266 5H14.031C14.5249 5 14.9827 5.28778 15.1266 5.76C15.319 6.39153 15.4165 7.04814 15.416 7.70833C15.416 8.57111 15.2521 9.395 14.9543 10.1517C14.7843 10.5817 14.351 10.8333 13.8882 10.8333H13.3032C13.041 10.8333 12.8893 10.5244 13.0255 10.3C13.4999 9.51889 13.7502 8.62224 13.7488 7.70833C13.7493 7.06579 13.6265 6.42918 13.386 5.83333Z" fill="#AEAEB2"/>
                                                            <path d="M12.981 10.4167C12.5332 10.4167 12.1293 10.6644 11.8527 11.0167C11.4219 11.5673 10.8804 12.0216 10.2632 12.35C9.86157 12.5633 9.51324 12.8811 9.3449 13.3028C9.2267 13.5982 9.16599 13.9135 9.16601 14.2317V14.5833C9.16601 14.6938 9.12211 14.7998 9.04397 14.878C8.96583 14.9561 8.85985 15 8.74935 15C8.41783 15 8.09988 14.8683 7.86546 14.6339C7.63104 14.3995 7.49935 14.0815 7.49935 13.75C7.49935 13.11 7.64379 12.5039 7.90101 11.9622C8.04879 11.6522 7.84157 11.25 7.49823 11.25M7.49823 11.25H5.76157C5.19157 11.25 4.68101 10.8644 4.62046 10.2972C4.59527 10.0628 4.58268 9.82482 4.58268 9.58333C4.58038 8.06314 5.09987 6.58821 6.05435 5.405C6.2699 5.13722 6.60268 5 6.94601 5H9.17712C9.4458 4.99984 9.71274 5.04298 9.96768 5.12778L11.6977 5.70556C11.9526 5.79035 12.2196 5.8335 12.4882 5.83333H13.386M7.49823 11.25H8.74935M13.386 5.83333C13.3397 5.71963 13.2897 5.60815 13.236 5.49889C13.1266 5.27667 13.2793 5 13.5266 5H14.031C14.5249 5 14.9827 5.28778 15.1266 5.76C15.319 6.39153 15.4165 7.04814 15.416 7.70833C15.416 8.57111 15.2521 9.395 14.9543 10.1517C14.7843 10.5817 14.351 10.8333 13.8882 10.8333H13.3032C13.041 10.8333 12.8893 10.5244 13.0255 10.3C13.4999 9.51889 13.7502 8.62224 13.7488 7.70833C13.7493 7.06579 13.6265 6.42918 13.386 5.83333Z" stroke="#8E8E93" stroke-width="0.583333" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                        :
                                                        <svg className='def_like' width="20" height="20" onClick={()=>DisLikeMes(n.id)} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M12.9791 10.4167C12.5313 10.4167 12.1274 10.6644 11.8507 11.0167C11.42 11.5673 10.8785 12.0216 10.2613 12.35C9.85962 12.5633 9.51128 12.8811 9.34295 13.3028C9.22475 13.5982 9.16403 13.9135 9.16406 14.2317V14.5833C9.16406 14.6938 9.12016 14.7998 9.04202 14.878C8.96388 14.9561 8.8579 15 8.74739 15C8.41587 15 8.09793 14.8683 7.86351 14.6339C7.62909 14.3995 7.49739 14.0815 7.49739 13.75C7.49739 13.11 7.64184 12.5039 7.89906 11.9622C8.04684 11.6522 7.83962 11.25 7.49628 11.25M7.49628 11.25H5.75962C5.18962 11.25 4.67906 10.8644 4.6185 10.2972C4.59332 10.0628 4.58073 9.82481 4.58073 9.58333C4.57843 8.06314 5.09792 6.58821 6.05239 5.405C6.26795 5.13722 6.60073 5 6.94406 5H9.17517C9.44384 4.99984 9.71079 5.04298 9.96573 5.12778L11.6957 5.70556C11.9507 5.79035 12.2176 5.8335 12.4863 5.83333H13.3841C13.3378 5.71963 13.2878 5.60815 13.2341 5.49889C13.1246 5.27667 13.2774 5 13.5246 5H14.0291C14.5229 5 14.9807 5.28778 15.1246 5.76C15.317 6.39153 15.4146 7.04814 15.4141 7.70833C15.4141 8.57111 15.2502 9.395 14.9524 10.1517C14.7824 10.5817 14.3491 10.8333 13.8863 10.8333H13.3013C13.0391 10.8333 12.8874 10.5244 13.0235 10.3C13.498 9.51889 13.7482 8.62224 13.7468 7.70833C13.7473 7.06579 13.624 6.42918 13.3835 5.83333M7.49628 11.25H8.74739" stroke="#8E8E93" stroke-width="0.583333" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                        }
                                                        <svg className='hov_like' onClick={()=>DisLikeMes(n.id)} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <rect x="20" y="20" width="20" height="20" rx="4" transform="rotate(180 20 20)" fill="#E5E5EA"/>
                                                            <path d="M12.981 10.4167C12.5332 10.4167 12.1293 10.6644 11.8527 11.0167C11.4219 11.5673 10.8804 12.0216 10.2632 12.35C9.86157 12.5633 9.51324 12.8811 9.3449 13.3028C9.2267 13.5982 9.16599 13.9135 9.16601 14.2317V14.5833C9.16601 14.6938 9.12211 14.7998 9.04397 14.878C8.96583 14.9561 8.85985 15 8.74935 15C8.41783 15 8.09988 14.8683 7.86546 14.6339C7.63104 14.3995 7.49935 14.0815 7.49935 13.75C7.49935 13.11 7.64379 12.5039 7.90101 11.9622C8.04879 11.6522 7.84157 11.25 7.49823 11.25M7.49823 11.25H5.76157C5.19157 11.25 4.68101 10.8644 4.62046 10.2972C4.59527 10.0628 4.58268 9.82481 4.58268 9.58333C4.58038 8.06314 5.09987 6.58821 6.05435 5.405C6.2699 5.13722 6.60268 5 6.94601 5H9.17712C9.4458 4.99984 9.71274 5.04298 9.96768 5.12778L11.6977 5.70556C11.9526 5.79035 12.2196 5.8335 12.4882 5.83333H13.386C13.3397 5.71963 13.2897 5.60815 13.236 5.49889C13.1266 5.27667 13.2793 5 13.5266 5H14.031C14.5249 5 14.9827 5.28778 15.1266 5.76C15.319 6.39153 15.4165 7.04814 15.416 7.70833C15.416 8.57111 15.2521 9.395 14.9543 10.1517C14.7843 10.5817 14.351 10.8333 13.8882 10.8333H13.3032C13.041 10.8333 12.8893 10.5244 13.0255 10.3C13.4999 9.51889 13.7502 8.62224 13.7488 7.70833C13.7493 7.06579 13.6259 6.42918 13.3855 5.83333M7.49823 11.25H8.74935" stroke="#8E8E93" stroke-width="0.583333" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>

                                                    </div>
                                                    {/* <div className='like'>
                                                        <span className='tolpipa_icon'>Regenerate</span>
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M12.7653 14.1651C13.7411 13.5189 14.4592 12.5507 14.7944 11.4294C15.1296 10.308 15.0606 9.10462 14.5995 8.02891C14.1384 6.9532 13.3144 6.07341 12.2712 5.54292C11.228 5.01242 10.0316 4.86487 8.89075 5.12597M12.7653 14.1651V12.2214M12.7653 14.1651H14.7217M7.22476 5.84401C6.25233 6.49258 5.53797 7.46148 5.20591 8.5822C4.87386 9.70292 4.94511 10.9046 5.40729 11.9782C5.86946 13.0518 6.69331 13.9295 7.73558 14.4586C8.77785 14.9877 9.97261 15.1348 11.1121 14.8742M7.22476 5.84401V7.77878M7.22476 5.84401H5.28111" stroke="#8E8E93" stroke-width="0.583097" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        {
                            load?
                            <div className='load_assistent'>
                                <Lottie animationData={Load} loop={true} />
                            </div>
                            :
                            <></>
                        }
                    </div>
                    <div className='assistant_messages_inputs'>
                        <div className='assistant_messages_tags'>
                            
                        </div>
                        <div className='assistant_messages_input'>
                            <div className='assistant_messages_skreppole'>
                                <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 13V7C1 5.4087 1.63214 3.88258 2.75736 2.75736C3.88258 1.63214 5.4087 1 7 1C8.5913 1 10.1174 1.63214 11.2426 2.75736C12.3679 3.88258 13 5.4087 13 7V15C13 16.0609 12.5786 17.0783 11.8284 17.8284C11.0783 18.5786 10.0609 19 9 19C7.93913 19 6.92172 18.5786 6.17157 17.8284C5.42143 17.0783 5 16.0609 5 15V7C5 6.46957 5.21071 5.96086 5.58579 5.58579C5.96086 5.21071 6.46957 5 7 5C7.53043 5 8.03914 5.21071 8.41421 5.58579C8.78929 5.96086 9 6.46957 9 7V15" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <textarea id='textarea' onKeyDown={handleKeyDown} onChange={setInput0} placeholder='Message AI-Assistant' value={input}></textarea>
                            </div>
                            {
                                load?
                                <div className={activbut?'assistant_messages_button active':'assistant_messages_button'} >
                                   
                                    {/* <svg className='stop_enter_svg' width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="36" height="36" rx="18" fill="black"/>
                                        <rect x="13.1328" y="13.1328" width="9.73438" height="9.73438" rx="2" fill="white"/>
                                    </svg> */}
                                    <svg className='stop_hover_svg' width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="36" height="36" rx="18" fill="#D1D1D6"/>
                                        <path d="M10.3092 17.0072C10.2555 17.0629 10.2134 17.1287 10.1851 17.2008C10.1569 17.2728 10.1431 17.3497 10.1446 17.4271C10.1477 17.5834 10.2126 17.732 10.3253 17.8404C10.4379 17.9488 10.589 18.0079 10.7452 18.0049C10.9015 18.0019 11.0502 17.9369 11.1585 17.8243L17.4128 11.3225V26.057C17.4128 26.2133 17.4749 26.3632 17.5854 26.4737C17.6959 26.5842 17.8458 26.6463 18.0021 26.6463C18.1584 26.6463 18.3083 26.5842 18.4188 26.4737C18.5293 26.3632 18.5914 26.2133 18.5914 26.057V11.3241L24.8441 17.8251C24.8977 17.8809 24.9619 17.9255 25.0328 17.9565C25.1037 17.9875 25.18 18.0042 25.2574 18.0057C25.3348 18.0072 25.4117 17.9935 25.4837 17.9652C25.5558 17.937 25.6216 17.8949 25.6773 17.8412C25.7331 17.7875 25.7778 17.7234 25.8088 17.6525C25.8397 17.5816 25.8565 17.5053 25.858 17.4279C25.8595 17.3505 25.8457 17.2736 25.8175 17.2016C25.7892 17.1295 25.7471 17.0637 25.6934 17.0079L18.5678 9.60023C18.4945 9.52407 18.4066 9.46348 18.3093 9.42209C18.212 9.38071 18.1074 9.35938 18.0017 9.35938C17.896 9.35938 17.7914 9.38071 17.6941 9.42209C17.5968 9.46348 17.5089 9.52407 17.4356 9.60023L10.3092 17.0072Z" fill="white"/>
                                    </svg>
                                </div>
                                :
                                <div className={activbut?'assistant_messages_button active':'assistant_messages_button'} onClick={activbut?()=>addmessages():undefined}>
                                   
                                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="36" height="36" rx="18" fill="#D1D1D6"/>
                                        <path d="M10.3092 17.0072C10.2555 17.0629 10.2134 17.1287 10.1851 17.2008C10.1569 17.2728 10.1431 17.3497 10.1446 17.4271C10.1477 17.5834 10.2126 17.732 10.3253 17.8404C10.4379 17.9488 10.589 18.0079 10.7452 18.0049C10.9015 18.0019 11.0502 17.9369 11.1585 17.8243L17.4128 11.3225V26.057C17.4128 26.2133 17.4749 26.3632 17.5854 26.4737C17.6959 26.5842 17.8458 26.6463 18.0021 26.6463C18.1584 26.6463 18.3083 26.5842 18.4188 26.4737C18.5293 26.3632 18.5914 26.2133 18.5914 26.057V11.3241L24.8441 17.8251C24.8977 17.8809 24.9619 17.9255 25.0328 17.9565C25.1037 17.9875 25.18 18.0042 25.2574 18.0057C25.3348 18.0072 25.4117 17.9935 25.4837 17.9652C25.5558 17.937 25.6216 17.8949 25.6773 17.8412C25.7331 17.7875 25.7778 17.7234 25.8088 17.6525C25.8397 17.5816 25.8565 17.5053 25.858 17.4279C25.8595 17.3505 25.8457 17.2736 25.8175 17.2016C25.7892 17.1295 25.7471 17.0637 25.6934 17.0079L18.5678 9.60023C18.4945 9.52407 18.4066 9.46348 18.3093 9.42209C18.212 9.38071 18.1074 9.35938 18.0017 9.35938C17.896 9.35938 17.7914 9.38071 17.6941 9.42209C17.5968 9.46348 17.5089 9.52407 17.4356 9.60023L10.3092 17.0072Z" fill="white"/>
                                    </svg>
                                    
                                </div>
                            }
                            
                        </div>
                    </div>
                </div>
                <div id="controls" className={shadow?'assistant_controls shadow':'assistant_controls'}>
                    <div id="resize" onMouseEnter={()=>setShadow(true)} onMouseLeave={()=>setShadow(false)} ref={ref} className='butt_resize'>
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="-0.5" y="-0.5" width="27" height="27" rx="13.5" transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 27 27)" fill="white" stroke="#DFE0E2"/>
                            <path d="M10.2816 11.3206C10.3188 11.3578 10.3484 11.4019 10.3685 11.4505C10.3887 11.4991 10.3991 11.5512 10.3991 11.6038C10.3991 11.6565 10.3887 11.7086 10.3685 11.7571C10.3484 11.8057 10.3188 11.8499 10.2816 11.887L8.96397 13.2038H12.7984C12.9045 13.2038 13.0062 13.246 13.0812 13.321C13.1562 13.396 13.1984 13.4978 13.1984 13.6038C13.1984 13.7099 13.1562 13.8117 13.0812 13.8867C13.0062 13.9617 12.9045 14.0038 12.7984 14.0038H8.96397L10.2816 15.3206C10.3567 15.3957 10.3989 15.4976 10.3989 15.6038C10.3989 15.7101 10.3567 15.8119 10.2816 15.887C10.2065 15.9621 10.1046 16.0043 9.99837 16.0043C9.89215 16.0043 9.79028 15.9621 9.71517 15.887L7.71517 13.887C7.67792 13.8499 7.64837 13.8057 7.6282 13.7571C7.60804 13.7086 7.59766 13.6565 7.59766 13.6038C7.59766 13.5512 7.60804 13.4991 7.6282 13.4505C7.64837 13.4019 7.67792 13.3578 7.71517 13.3206L9.71517 11.3206C9.75233 11.2834 9.79647 11.2538 9.84506 11.2337C9.89366 11.2135 9.94576 11.2031 9.99837 11.2031C10.051 11.2031 10.1031 11.2135 10.1517 11.2337C10.2003 11.2538 10.2444 11.2834 10.2816 11.3206ZM17.7152 11.3206C17.7523 11.2834 17.7965 11.2538 17.8451 11.2337C17.8937 11.2135 17.9458 11.2031 17.9984 11.2031C18.051 11.2031 18.1031 11.2135 18.1517 11.2337C18.2003 11.2538 18.2444 11.2834 18.2816 11.3206L20.2816 13.3206C20.3188 13.3578 20.3484 13.4019 20.3685 13.4505C20.3887 13.4991 20.3991 13.5512 20.3991 13.6038C20.3991 13.6565 20.3887 13.7086 20.3685 13.7571C20.3484 13.8057 20.3188 13.8499 20.2816 13.887L18.2816 15.887C18.2065 15.9621 18.1046 16.0043 17.9984 16.0043C17.8921 16.0043 17.7903 15.9621 17.7152 15.887C17.6401 15.8119 17.5979 15.7101 17.5979 15.6038C17.5979 15.4976 17.6401 15.3957 17.7152 15.3206L19.0328 14.0038H15.1984C15.0923 14.0038 14.9905 13.9617 14.9155 13.8867C14.8405 13.8117 14.7984 13.7099 14.7984 13.6038C14.7984 13.4978 14.8405 13.396 14.9155 13.321C14.9905 13.246 15.0923 13.2038 15.1984 13.2038H19.0328L17.7152 11.887C17.6779 11.8499 17.6484 11.8057 17.6282 11.7571C17.608 11.7086 17.5977 11.6565 17.5977 11.6038C17.5977 11.5512 17.608 11.4991 17.6282 11.4505C17.6484 11.4019 17.6779 11.3578 17.7152 11.3206Z" fill="black"/>
                        </svg>
                    </div>
                    
                    <div className={load2?'head_controls inactive':'head_controls'}>
                        <div className='tab_controls_block' >
                            <div className={activemenu==1||activemenu==4?'tab_controls_block_menu active':'tab_controls_block_menu'} onClick={()=>setActiveMenu0(1)}>
                                Campaign
                            </div>
                        </div>
                        <div className='tab_controls_block inactive' >
                            <div className={activemenu==2?'tab_controls_block_menu active':'tab_controls_block_menu'} >
                                Sequence
                                <span>Soon</span>
                            </div>
                        </div>
                        <div className='tab_controls_block inactive' >
                            <div className={activemenu==3?'tab_controls_block_menu active':'tab_controls_block_menu'} >
                                Messages
                                <span>Soon</span>
                            </div>
                        </div>
                    </div>
                    {
                        /*inactive */
                    }
                     <div className={load2?'body_controls inactive':'body_controls'}>
                        {
                            activemenu==1? // tab 1
                            <div className='body_controls_block'>
                                <div className='body_controls_block_line_sin_company'>
                                    <div className='body_compain_block_line_title'>Goal:<span>{goal}</span></div>
                                </div>
                                <div className='body_controls_block_line'>
                                    {
                                        editCompany?
                                        <div className='body_controls_block_line_name_desc active'>
                                            <div className='body_controls_block_line_name'>
                                                <div className='body_controls_block_line_name_title active'>
                                                    {
                                                        idError?
                                                        <div className='error_input'>
                                                        <input type='text' placeholder='Campaign name'  value={nameCompany} onChange={e=>setNameCompany0(e.target.value)} />
                                                        <p>The name must be unique </p>
                                                        </div>
                                                        :
                                                        <input type='text' placeholder='Campaign name'  value={nameCompany} onChange={e=>setNameCompany0(e.target.value)} />
                                                    }
                                                    
                                                    <textarea value={descCompany} placeholder='Type description' onChange={e=>setDescCompany(e.target.value)}  ></textarea>
                                                </div>
                                            </div>
                                            <div className='body_controls_block_line_name body_controls_block_line_but'>
                                                <div className={nameCompany!=""&&descCompany!=""?'compain_save active':'compain_save'} onClick={nameCompany!=""&&descCompany!=""?()=>editCompain():undefined}>Save
                                                </div>
                                                <div className='compain_cancel' onClick={()=>setEditCompany0(false)}>Cancel
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className='body_controls_block_line_name_desc'>
                                            <div className='body_controls_block_line_name'>
                                                <div className='body_controls_block_line_name_title'>
                                                    <input type='text' placeholder='Campaign name' value={nameCompany} disabled/>
                                                </div>
                                                <div className='body_controls_block_line_name_edit' onClick={()=>setEditCompany(true)}>
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_5292_38499)">
                                                        <path d="M11.8009 5.26526L4.86567 12.2009C4.65721 12.4094 4.51334 12.6736 4.45135 12.9618L3.88479 15.5942C3.86941 15.6657 3.87219 15.7398 3.89286 15.81C3.91353 15.8801 3.95145 15.9439 4.00314 15.9956C4.05483 16.0473 4.11865 16.0852 4.18877 16.1059C4.25889 16.1266 4.33307 16.1293 4.40454 16.1139L7.04354 15.5452C7.33153 15.4832 7.59554 15.3395 7.80392 15.1313L15.5184 7.41688C15.8988 7.02599 16.11 6.50101 16.1063 5.95554C16.1027 5.41008 15.8843 4.88801 15.4986 4.5023C15.1129 4.11659 14.5908 3.89827 14.0454 3.89458C13.4999 3.89089 12.9749 4.10212 12.584 4.48257L11.8276 5.23857L11.8009 5.26526ZM12.8934 4.79188C13.2017 4.49102 13.6162 4.3238 14.047 4.32645C14.4778 4.32911 14.8902 4.50142 15.1949 4.80605C15.4995 5.11069 15.6718 5.52309 15.6745 5.9539C15.6771 6.38471 15.5099 6.79921 15.209 7.10757L14.5944 7.72226L12.2787 5.40657L12.8934 4.79188ZM11.9685 5.71588L14.2842 8.03157L7.49417 14.8216C7.34533 14.9705 7.15665 15.0734 6.95079 15.1178L4.31223 15.6865L4.87835 13.0536C4.92271 12.8478 5.02556 12.6591 5.17454 12.5103L11.9685 5.71588Z" fill="#8E8E93"/>
                                                        </g>
                                                        <defs>
                                                        <clipPath id="clip0_5292_38499">
                                                        <rect width="14" height="14" fill="white" transform="translate(3 3)"/>
                                                        </clipPath>
                                                        </defs>
                                                    </svg>
                                                    Edit 
                                                </div>
                                            </div>
                                            <div className='body_controls_block_line_name body_controls_block_line_textarea_comapin'>
                                                <div className={allText?'textarea_comapin':'textarea_comapin inactive'} ref={textRef}>
                                                    {descCompany}
                                                </div>
                                            </div>
                                            {descCompany&& descCompany.length>200 && !allText &&
                                                <div className='body_controls_block_line_name' onClick={()=>setAllText(true)}>
                                                    <div className="body_controls_block_line_arrow">
                                                        <svg width="17" height="8" viewBox="0 0 17 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clip-path="url(#clip0_3121_110334)">
                                                            <path d="M4.88812 1.63466L4.18146 2.34199L8.03279 6.19466C8.0945 6.25676 8.16789 6.30605 8.24872 6.33968C8.32955 6.37331 8.41624 6.39063 8.50379 6.39063C8.59134 6.39063 8.67803 6.37331 8.75886 6.33968C8.8397 6.30605 8.91308 6.25676 8.97479 6.19466L12.8281 2.34199L12.1215 1.63532L8.50479 5.25132L4.88812 1.63466Z" fill="black"/>
                                                            </g>
                                                            <defs>
                                                            <clipPath id="clip0_3121_110334">
                                                            <rect width="8" height="16" fill="white" transform="matrix(4.37114e-08 1 1 -4.37114e-08 0.5 0)"/>
                                                            </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </div>
                                                </div>
                                            }
                                            {descCompany&& descCompany.length>200 && allText &&
                                                <div className='body_controls_block_line_name' onClick={()=>setAllText(false)}>
                                                    <div className="body_controls_block_line_arrow" >
                                                        <svg width="17" height="8" viewBox="0 0 17 8" fill="none" xmlns="http://www.w3.org/2000/svg" style={{transform:"rotate(180deg)"}}>
                                                            <g clip-path="url(#clip0_3121_110334)">
                                                            <path d="M4.88812 1.63466L4.18146 2.34199L8.03279 6.19466C8.0945 6.25676 8.16789 6.30605 8.24872 6.33968C8.32955 6.37331 8.41624 6.39063 8.50379 6.39063C8.59134 6.39063 8.67803 6.37331 8.75886 6.33968C8.8397 6.30605 8.91308 6.25676 8.97479 6.19466L12.8281 2.34199L12.1215 1.63532L8.50479 5.25132L4.88812 1.63466Z" fill="black"/>
                                                            </g>
                                                            <defs>
                                                            <clipPath id="clip0_3121_110334">
                                                            <rect width="8" height="16" fill="white" transform="matrix(4.37114e-08 1 1 -4.37114e-08 0.5 0)"/>
                                                            </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                                <div className='body_controls_block_line_sin_company'>
                                    <div className='body_controls_block_line_name_desc audience'>
                                        <div className='body_controls_block_line_name'>
                                            <div className='body_controls_block_line_audience'>
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g opacity="0.8">
                                                    <path d="M7.79395 6.84766C9.23345 6.84766 10.4004 5.68071 10.4004 4.24121C10.4004 2.80171 9.23345 1.63477 7.79395 1.63477C6.35445 1.63477 5.1875 2.80171 5.1875 4.24121C5.1875 5.68071 6.35445 6.84766 7.79395 6.84766Z" stroke="#007AFF" stroke-width="0.8"/>
                                                    <path d="M13.0508 11.734C13.0508 13.3533 13.0508 14.6663 7.83789 14.6663C2.625 14.6663 2.625 13.3533 2.625 11.734C2.625 10.1148 4.95907 8.80176 7.83789 8.80176C10.7167 8.80176 13.0508 10.1148 13.0508 11.734Z" stroke="#007AFF" stroke-width="0.8"/>
                                                    </g>
                                                </svg>
                                                Audience
                                                <div className='body_controls_block_line_audience_reg'>
                                                    {compain?.clientsInCampaign}
                                                    <span>{compain?.clientsInCampaignPercent}%</span>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                                <div className='body_controls_block_line_sin_company line_attr_select'>
                                    {
                                        listAttribute?.map((p, id)=>
                                            p.type?
                                            <div className='body_controls_block_line_add_audience_active iactive_block' >
                                                <div className='active_select_title'>
                                                    {p.namecheck}
                                                    <div className='edit_delete_block' >
                                                        <svg className='tooltipe_icon_open' onClick={()=>setTooltipe(true)} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <rect y="24" width="24" height="24" rx="4" transform="rotate(-90 0 24)" fill="#EFEFF0"/>
                                                            <path d="M5.41406 13.3125C5.76216 13.3125 6.096 13.1742 6.34214 12.9281C6.58828 12.6819 6.72656 12.3481 6.72656 12C6.72656 11.6519 6.58828 11.3181 6.34214 11.0719C6.096 10.8258 5.76216 10.6875 5.41406 10.6875C5.06597 10.6875 4.73213 10.8258 4.48598 11.0719C4.23984 11.3181 4.10156 11.6519 4.10156 12C4.10156 12.3481 4.23984 12.6819 4.48598 12.9281C4.73213 13.1742 5.06597 13.3125 5.41406 13.3125ZM11.9766 13.3125C12.3247 13.3125 12.6585 13.1742 12.9046 12.9281C13.1508 12.6819 13.2891 12.3481 13.2891 12C13.2891 11.6519 13.1508 11.3181 12.9046 11.0719C12.6585 10.8258 12.3247 10.6875 11.9766 10.6875C11.6285 10.6875 11.2946 10.8258 11.0485 11.0719C10.8023 11.3181 10.6641 11.6519 10.6641 12C10.6641 12.3481 10.8023 12.6819 11.0485 12.9281C11.2946 13.1742 11.6285 13.3125 11.9766 13.3125ZM18.5391 13.3125C18.8872 13.3125 19.221 13.1742 19.4671 12.9281C19.7133 12.6819 19.8516 12.3481 19.8516 12C19.8516 11.6519 19.7133 11.3181 19.4671 11.0719C19.221 10.8258 18.8872 10.6875 18.5391 10.6875C18.191 10.6875 17.8571 10.8258 17.611 11.0719C17.3648 11.3181 17.2266 11.6519 17.2266 12C17.2266 12.3481 17.3648 12.6819 17.611 12.9281C17.8571 13.1742 18.191 13.3125 18.5391 13.3125Z" fill="black"/>
                                                        </svg>
                                                        <div className='tooltipe_strategy tooltipe_company'>
                                                            
                                                            <div onClick={()=>editToolComp(id)} className='tooltipe_strategy_line'>
                                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <g clip-path="url(#clip0_4130_60803)">
                                                                    <path d="M11.8009 5.26526L4.86567 12.2009C4.65721 12.4094 4.51334 12.6736 4.45135 12.9618L3.88479 15.5942C3.86941 15.6657 3.87219 15.7398 3.89286 15.81C3.91353 15.8801 3.95145 15.9439 4.00314 15.9956C4.05483 16.0473 4.11865 16.0852 4.18877 16.1059C4.25889 16.1266 4.33307 16.1293 4.40454 16.1139L7.04354 15.5452C7.33153 15.4832 7.59554 15.3395 7.80392 15.1313L15.5184 7.41688C15.8988 7.02599 16.11 6.50101 16.1063 5.95554C16.1027 5.41008 15.8843 4.88801 15.4986 4.5023C15.1129 4.11659 14.5908 3.89827 14.0454 3.89458C13.4999 3.89089 12.9749 4.10212 12.584 4.48257L11.8276 5.23857L11.8009 5.26526ZM12.8934 4.79188C13.2017 4.49102 13.6162 4.3238 14.047 4.32645C14.4778 4.32911 14.8902 4.50142 15.1949 4.80605C15.4995 5.11069 15.6718 5.52309 15.6745 5.9539C15.6771 6.38471 15.5099 6.79921 15.209 7.10757L14.5944 7.72226L12.2787 5.40657L12.8934 4.79188ZM11.9685 5.71588L14.2842 8.03157L7.49417 14.8216C7.34533 14.9705 7.15665 15.0734 6.95079 15.1178L4.31223 15.6865L4.87835 13.0536C4.92271 12.8478 5.02556 12.6591 5.17454 12.5103L11.9685 5.71588Z" fill="#8E8E93"/>
                                                                    </g>
                                                                    <defs>
                                                                    <clipPath id="clip0_4130_60803">
                                                                    <rect width="14" height="14" fill="white" transform="translate(3 3)"/>
                                                                    </clipPath>
                                                                    </defs>
                                                                </svg>
                                                                Edit 
                                                            </div>
                                                            <div onClick={() => deleteCompain(p.id)} className='tooltipe_strategy_line'>
                                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M8.6 5.27617H11.4C11.4 4.90487 11.2525 4.54877 10.9899 4.28622C10.7274 4.02367 10.3713 3.87617 10 3.87617C9.6287 3.87617 9.2726 4.02367 9.01005 4.28622C8.7475 4.54877 8.6 4.90487 8.6 5.27617ZM7.55 5.27617C7.55 4.95443 7.61337 4.63585 7.7365 4.3386C7.85962 4.04135 8.04008 3.77126 8.26759 3.54376C8.49509 3.31626 8.76518 3.13579 9.06243 3.01267C9.35967 2.88954 9.67826 2.82617 10 2.82617C10.3217 2.82617 10.6403 2.88954 10.9376 3.01267C11.2348 3.13579 11.5049 3.31626 11.7324 3.54376C11.9599 3.77126 12.1404 4.04135 12.2635 4.3386C12.3866 4.63585 12.45 4.95443 12.45 5.27617H16.475C16.6142 5.27617 16.7478 5.33148 16.8462 5.42994C16.9447 5.5284 17 5.66193 17 5.80117C17 5.94041 16.9447 6.07395 16.8462 6.1724C16.7478 6.27086 16.6142 6.32617 16.475 6.32617H15.551L14.732 14.8039C14.6692 15.4535 14.3666 16.0563 13.8834 16.495C13.4001 16.9336 12.7708 17.1764 12.1182 17.1762H7.8818C7.2293 17.1762 6.60017 16.9333 6.11706 16.4947C5.63396 16.0561 5.33151 15.4533 5.2687 14.8039L4.449 6.32617H3.525C3.38576 6.32617 3.25223 6.27086 3.15377 6.1724C3.05531 6.07395 3 5.94041 3 5.80117C3 5.66193 3.05531 5.5284 3.15377 5.42994C3.25223 5.33148 3.38576 5.27617 3.525 5.27617H7.55ZM8.95 8.60117C8.95 8.46193 8.89469 8.3284 8.79623 8.22994C8.69777 8.13148 8.56424 8.07617 8.425 8.07617C8.28576 8.07617 8.15223 8.13148 8.05377 8.22994C7.95531 8.3284 7.9 8.46193 7.9 8.60117V13.8512C7.9 13.9904 7.95531 14.1239 8.05377 14.2224C8.15223 14.3209 8.28576 14.3762 8.425 14.3762C8.56424 14.3762 8.69777 14.3209 8.79623 14.2224C8.89469 14.1239 8.95 13.9904 8.95 13.8512V8.60117ZM11.575 8.07617C11.7142 8.07617 11.8478 8.13148 11.9462 8.22994C12.0447 8.3284 12.1 8.46193 12.1 8.60117V13.8512C12.1 13.9904 12.0447 14.1239 11.9462 14.2224C11.8478 14.3209 11.7142 14.3762 11.575 14.3762C11.4358 14.3762 11.3022 14.3209 11.2038 14.2224C11.1053 14.1239 11.05 13.9904 11.05 13.8512V8.60117C11.05 8.46193 11.1053 8.3284 11.2038 8.22994C11.3022 8.13148 11.4358 8.07617 11.575 8.07617ZM6.3138 14.7031C6.35156 15.0927 6.53307 15.4544 6.82296 15.7174C7.11284 15.9805 7.49032 16.1263 7.8818 16.1262H12.1182C12.5097 16.1263 12.8872 15.9805 13.177 15.7174C13.4669 15.4544 13.6484 15.0927 13.6862 14.7031L14.4968 6.32617H5.5032L6.3138 14.7031Z" fill="#FF3B30"/>
                                                                </svg>
                                                                {langv?.strategy?.button_6}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='body_iactive_select'>
                                                    {/* {
                                                        p.list.map((g, id2)=>
                                                            g.name==p.namecheck?
                                                            g.list.map((t, id3)=>
                                                                t.check?
                                                                    <div className='body_iactive_select_bl' >
                                                                        {t.name}
                                                                        <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <g opacity="0.8">
                                                                            <path d="M6.59546 5.13623C7.67508 5.13623 8.55029 4.26102 8.55029 3.1814C8.55029 2.10177 7.67508 1.22656 6.59546 1.22656C5.51583 1.22656 4.64062 2.10177 4.64062 3.1814C4.64062 4.26102 5.51583 5.13623 6.59546 5.13623Z" stroke="#007AFF" stroke-width="0.8"/>
                                                                            <path d="M10.5381 8.80173C10.5381 10.0162 10.5381 11.0009 6.62842 11.0009C2.71875 11.0009 2.71875 10.0162 2.71875 8.80173C2.71875 7.58729 4.4693 6.60254 6.62842 6.60254C8.78753 6.60254 10.5381 7.58729 10.5381 8.80173Z" stroke="#007AFF" stroke-width="0.8"/>
                                                                            </g>
                                                                        </svg>
                                                                        <span>{t.count}</span>    
                                                                    </div>
                                                                    :
                                                                    <></>
                                                                }
                                                            )
                                                            :
                                                            <></>
                                                        )
                                                    } */}
                                                    <TagBlock
                                                        list={
                                                            p.list.find(g => g.name === p.namecheck)?.list.filter(item => item.check) || []
                                                        }
                                                        listAttribute = {listAttribute}
                                                    />
                                                </div>
                                            </div>
                                            :
                                            <div className='body_controls_block_line_add_audience_active'>
                                                <div className='body_controls_block_line_add_audience_active_select' onClick={()=>openSelectAttr(id)}>
                                                    {p.namecheck!=""?p.namecheck:"Select attribute"}
                                                    <svg className={p.open?"active_select_svg":""} width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.30859 3.07715)" fill="#020203"/>
                                                        <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.30859 3.07715)" fill="black" fill-opacity="0.2"/>
                                                        <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.30859 3.07715)" fill="black" fill-opacity="0.2"/>
                                                        <path d="M0.691406 3.84615L7.03173 10L12.9991 3.84615" stroke="#020203"/>
                                                        <path d="M0.691406 3.84615L7.03173 10L12.9991 3.84615" stroke="black" stroke-opacity="0.2"/>
                                                        <path d="M0.691406 3.84615L7.03173 10L12.9991 3.84615" stroke="black" stroke-opacity="0.2"/>
                                                    </svg>
                                                </div>
                                                {
                                                    p.open?
                                                    <div className='body_active_select'>
                                                        <div className='body_active_select_scroll'>
                                                        {
                                                            p.list?.map((n, id2)=>
                                                                <span onClick={()=>changeAttrSelect(id, n.name, n.id_attr)}>{n.name}</span>
                                                            )
                                                        }
                                                        </div>
                                                    </div>
                                                    :
                                                    <></>
                                                }
                                                <div className='body_controls_block_line_inactive_select'>
                                                    {
                                                        p.namecheck!=""?
                                                        <div className='add_audience_ranks'>
                                                            <div className='add_audience_ranks_title'>
                                                                Range
                                                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <g opacity="0.8">
                                                                    <path d="M5.84546 5.13623C6.92508 5.13623 7.80029 4.26102 7.80029 3.1814C7.80029 2.10177 6.92508 1.22656 5.84546 1.22656C4.76583 1.22656 3.89062 2.10177 3.89062 3.1814C3.89062 4.26102 4.76583 5.13623 5.84546 5.13623Z" stroke="#007AFF" stroke-width="0.8"/>
                                                                    <path d="M9.78809 8.80173C9.78809 10.0162 9.78809 11.0009 5.87842 11.0009C1.96875 11.0009 1.96875 10.0162 1.96875 8.80173C1.96875 7.58729 3.7193 6.60254 5.87842 6.60254C8.03753 6.60254 9.78809 7.58729 9.78809 8.80173Z" stroke="#007AFF" stroke-width="0.8"/>
                                                                    </g>
                                                                </svg>
                                                            </div>
                                                            <div className='add_audience_ranks_list'>
                                                                <div className='add_audience_ranks_list_block'>
                                                                {
                                                                    p.list.map((g, id2)=>
                                                                        g.name==p.namecheck?
                                                                        g.list.map((t, id3)=>
                                                                            <div className='add_audience_rank'>
                                                                                <div className='audience_rank_title' onClick={()=>changeCheckListAttr(id, id2, id3)}>
                                                                                    {t.check?
                                                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                            <rect x="3" y="3" width="14" height="14" rx="2" fill="white"/>
                                                                                            <path d="M5.20833 2.5C4.49004 2.5 3.80116 2.78534 3.29325 3.29325C2.78534 3.80116 2.5 4.49004 2.5 5.20833V14.7917C2.5 15.51 2.78534 16.1988 3.29325 16.7067C3.80116 17.2147 4.49004 17.5 5.20833 17.5H14.7917C15.51 17.5 16.1988 17.2147 16.7067 16.7067C17.2147 16.1988 17.5 15.51 17.5 14.7917V5.20833C17.5 4.49004 17.2147 3.80116 16.7067 3.29325C16.1988 2.78534 15.51 2.5 14.7917 2.5H5.20833ZM3.75 5.20833C3.75 4.40333 4.40333 3.75 5.20833 3.75H14.7917C15.5967 3.75 16.25 4.40333 16.25 5.20833V14.7917C16.25 15.1784 16.0964 15.5494 15.8229 15.8229C15.5494 16.0964 15.1784 16.25 14.7917 16.25H5.20833C4.82156 16.25 4.45063 16.0964 4.17714 15.8229C3.90365 15.5494 3.75 15.1784 3.75 14.7917V5.20833ZM14.4 7.73333C14.4614 7.67611 14.5107 7.60711 14.5448 7.53045C14.579 7.45378 14.5973 7.37102 14.5988 7.2871C14.6003 7.20318 14.5849 7.11983 14.5534 7.042C14.522 6.96418 14.4752 6.89348 14.4159 6.83414C14.3565 6.77479 14.2858 6.728 14.208 6.69656C14.1302 6.66513 14.0468 6.64969 13.9629 6.65117C13.879 6.65265 13.7962 6.67102 13.7196 6.70518C13.6429 6.73934 13.5739 6.78859 13.5167 6.85L8.33083 12.03L6.48333 10.1833C6.36485 10.0729 6.20815 10.0128 6.04623 10.0157C5.88431 10.0185 5.72983 10.0841 5.61531 10.1986C5.5008 10.3132 5.43521 10.4676 5.43235 10.6296C5.4295 10.7915 5.4896 10.9482 5.6 11.0667L7.8875 13.355C8.00469 13.472 8.16354 13.5378 8.32917 13.5378C8.49479 13.5378 8.65365 13.472 8.77083 13.355L14.4 7.73333Z" fill="#34C759"/>
                                                                                        </svg>
                                                                                        :
                                                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                            <rect x="3" y="3.00098" width="14" height="14" rx="2" fill="white"/>
                                                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.23679 3.33301H14.7606C15.2658 3.33301 15.7503 3.53369 16.1075 3.8909C16.4647 4.24811 16.6654 4.7326 16.6654 5.23777V14.7616C16.6654 15.2668 16.4647 15.7512 16.1075 16.1084C15.7503 16.4657 15.2658 16.6663 14.7606 16.6663H5.23679C4.73162 16.6663 4.24714 16.4657 3.88992 16.1084C3.53271 15.7512 3.33203 15.2668 3.33203 14.7616V5.23777C3.33203 4.7326 3.53271 4.24811 3.88992 3.8909C4.24714 3.53369 4.73162 3.33301 5.23679 3.33301Z" stroke="#C7C7CC" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                        </svg>
                                                                                    }
                                                                                    
                                                                                    {t.name}
                                                                                </div>
                                                                                <div className='audience_rank_val'>
                                                                                    {t.count}
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                        :
                                                                        <></>
                                                                    )
                                                                }
                                                                </div>
                                                            </div>
                                                            <div className='add_audience_ranks_bottom'>
                                                                <div className='add_audience_ranks_selected'>Selected (0) -&nbsp;</div>
                                                                <div className='add_audience_ranks_selectall'>Select all</div>
                                                            </div>
                                                        </div>
                                                        :
                                                        <svg width="37" height="24" viewBox="0 0 37 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M18.682 23.8504C17.4219 23.9014 16.1458 23.4247 15.1838 22.4203C14.374 21.5748 13.9224 20.497 13.8289 19.3924C13.006 12.8342 11.0595 10.7982 4.78391 9.9375C3.72222 9.84204 2.68574 9.37016 1.87326 8.52186C0.0422475 6.61012 0.042248 3.51058 1.87326 1.59884C3.70427 -0.312895 6.67292 -0.312895 8.50393 1.59884C9.2694 2.39806 9.71486 3.40487 9.84031 4.4457L9.84289 4.443C10.1691 7.13875 10.6758 9.08392 11.5778 10.5026C12.8187 12.6998 15.4623 14.2169 18.5233 14.2169C21.8004 14.2169 24.5993 12.4778 25.7103 10.027C26.4198 8.69539 26.8498 6.94973 27.1403 4.64406C27.2308 3.53401 27.6829 2.45007 28.4965 1.60063C30.3275 -0.311106 33.2962 -0.311106 35.1272 1.60063C36.9582 3.51237 36.9582 6.61191 35.1272 8.52365C34.362 9.32253 33.3982 9.78758 32.4018 9.91878L32.4034 9.92054C25.9284 10.7746 23.9746 12.8145 23.1566 19.5751L23.1549 19.5733C23.0295 20.6141 22.584 21.6209 21.8186 22.4201C20.9485 23.3285 19.8217 23.8053 18.682 23.8504Z" fill="#E5E5EA"/>
                                                            <path d="M15.2131 8.35682C13.3821 6.44508 13.3821 3.34554 15.2131 1.4338C17.0441 -0.477935 20.0128 -0.477934 21.8438 1.4338C23.6748 3.34554 23.6748 6.44508 21.8438 8.35682C20.0128 10.2686 17.0441 10.2686 15.2131 8.35682Z" fill="#E5E5EA"/>
                                                            <path d="M27.9632 22.5662C26.1322 20.6545 26.1322 17.5549 27.9632 15.6432C29.7942 13.7314 32.7628 13.7314 34.5939 15.6432C36.4249 17.5549 36.4249 20.6545 34.5939 22.5662C32.7628 24.4779 29.7942 24.4779 27.9632 22.5662Z" fill="#E5E5EA"/>
                                                            <path d="M1.88107 22.5662C0.0500595 20.6545 0.0500598 17.5549 1.88107 15.6432C3.71208 13.7314 6.68074 13.7314 8.51175 15.6432C10.3428 17.5549 10.3428 20.6545 8.51175 22.5662C6.68074 24.4779 3.71208 24.4779 1.88107 22.5662Z" fill="#E5E5EA"/>
                                                        </svg>
                                                    }
                                                   
                                                </div>
                                                <div className='body_controls_block_line_name body_controls_block_line_center'>
                                                    <div className={p.namecheck!=""?'compain_save active':'compain_save'} onClick={()=>addSelectAttr(id, p.id)}>Add
                                                    </div>
                                                    <div className='compain_cancel' onClick={()=>closeToolComp()}>Cancel
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                       
                                        <div className={'body_controls_block_line_add_audience' + (isAddInactive ? " inactive" : "") }
                                            onClick={()=>{const hasEmptyName = listAttribute.some(item => item.namecheck === "");
                                               if (listAttribute.length > 0 && hasEmptyName) {}
                                               else {setEditAddCompany();}
                                            }}>
                                            
                                            Add attribute 
                                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M16.7113 7.71053C16.89 8.01993 16.89 8.40112 16.7113 8.71053L13.1834 14.8211C13.0048 15.1305 12.6747 15.3211 12.3174 15.3211L5.26156 15.3211C4.90429 15.3211 4.57417 15.1305 4.39553 14.8211L0.867622 8.71053C0.688989 8.40112 0.688989 8.01993 0.867622 7.71053L4.39554 1.6C4.57417 1.2906 4.90429 1.1 5.26156 1.1L12.3174 1.1C12.6747 1.1 13.0048 1.2906 13.1834 1.6L16.7113 7.71053Z" fill="#F5C538" stroke="#F5C538" stroke-width="0.5"/>
                                                <path d="M9 4.5V11.5" stroke="#020203" stroke-width="0.5" stroke-linecap="round"/>
                                                <path d="M9 4.5V11.5" stroke="black" stroke-opacity="0.2" stroke-width="0.5" stroke-linecap="round"/>
                                                <path d="M9 4.5V11.5" stroke="black" stroke-opacity="0.2" stroke-width="0.5" stroke-linecap="round"/>
                                                <path d="M5.5 8H12.5" stroke="#020203" stroke-width="0.5" stroke-linecap="round"/>
                                                <path d="M5.5 8H12.5" stroke="black" stroke-opacity="0.2" stroke-width="0.5" stroke-linecap="round"/>
                                                <path d="M5.5 8H12.5" stroke="black" stroke-opacity="0.2" stroke-width="0.5" stroke-linecap="round"/>
                                            </svg>
                                        </div>
                                    
                                </div>
                            </div>
                            :
                            <></>
                        }
                    </div>
                    
                    {
                        load2?
                        <div className='load_assistent_body'>
                            <Lottie animationData={Load} loop={true} />
                        </div>
                        :
                        <></>
                    }
                </div>
            </div>
        </>
    );
})

export default Assistant;
